import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Button, Stack } from '@lyearn/ui';
import { typography } from '@/consts/typography';

import { FilterActionProps } from './types';

function FilterActionsMobile(props: FilterActionProps) {
  const { t } = useTranslation();
  const { onClear, onSave, disabled, className } = props;

  return (
    <Stack
      alignItems="center"
      className={cn('flex-shrink-0 p-16', className)}
      justifyContent="center">
      <Button
        fullWidth
        appearance="secondary"
        className="me-12"
        shape="pill"
        size="x-large"
        typography={typography}
        variant="outlined"
        onClick={onClear}>
        {t('Common:Actions.Clear')}
      </Button>
      <Button
        fullWidth
        disabled={disabled}
        shape="pill"
        size="x-large"
        typography={typography}
        onClick={onSave}>
        {t('Common:Actions.Apply')}
      </Button>
    </Stack>
  );
}

export default React.memo(FilterActionsMobile);
